import { useNavigation } from '@zet/common/hooks/useNavigation'
import { useEnv } from '@zet/common/providers/envProvider'
import { LeadStatus } from '@zet/utils/Constants'

interface useRaiseDisputeNavigationProps {
  item?: {
    id: number
    phoneNumber: number
    email: string
    status: string
  }
  user?: {
    zetCode: number
    email: string
    fullName: string
    phoneNumber: number
  }
  brandName: string
}

const raiseDisputeLead = 'Raise complaint for lead'

const useRaiseDisputeNavigation = ({
  item,
  user,
  brandName,
}: useRaiseDisputeNavigationProps) => {
  const env = useEnv()
  const { navigate } = useNavigation()
  const isRaiseDisputeAllowed =
    item?.status === LeadStatus.ACTION_REQUIRED ||
    item?.status === LeadStatus.REJECTED

  const raiseDisputeNavigation = () => {
    navigate('WebViewScreen', {
      url:
        `${env?.FRESHDESK_DISPUTE_URL}?onecode=${user?.zetCode}&agentName=${
          user?.fullName
        }&agentEmail=${user?.email ? user?.email : ''}&agentNumber=${
          user?.phoneNumber
        }&leadID=${item?.id}&cxMobNum=${item?.phoneNumber}&cxEmail=${
          item?.email ? item?.email : ''
        }&partnerName=${
          brandName ? brandName : ''
        }&disputeSource=${raiseDisputeLead}&time=` + Date.now(),
    })
  }

  return { raiseDisputeNavigation, isRaiseDisputeAllowed }
}

export default useRaiseDisputeNavigation
